// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"af0b9e90","508":"af0b9e90","558":"af0b9e90","701":"af0b9e90"}[chunkId] + ".chunk.css";
};